import React from "react";
import statistika1 from "../assets/image/statistika1.jpg";
import statistika2 from "../assets/image/statistika2.jpg";
const Statistika = () => {
  const statistics = `
    <ul>
    <strong>Market Zənciri və Pərakəndə Sənayesi:</strong>
      <li>Turan Özbahçeci, 52 supermarket açaraq böyük bir uğur əldə etmişdir.</li>
      <li>Bu marketlərin böyük bir hissəsi, İngiltərə mərkəzli TESCO'ya satılmışdır.</li>
      <li>O, İstanbul Pərakəndəçilər Dərnəyində 2 il başqanlıq etmiş və Fayda Mağazacılıq markasını quraraq Türkiyənin mühüm pərakəndə markalarından birini yaratmışdır.</li>
    </ul>
    
    <ul>
    <strong>Araz Supermarketləri:</strong>
      <li>2010-cu ildə qurulan Araz Supermarketləri, bu gün Azərbaycanın ən böyük supermarket zəncirlərindən biri olmuşdur.</li>
      <li>Şirkət, sürətlə böyüyərək ölkə daxilində əhəmiyyətli bir bazar payı əldə etmişdir.</li>
    </ul>
    
    <ul>
    <strong>İxracat və İstehsalat:</strong>
      <li>Turan Özbahçeci'nin qurduğu “Lalona” markalı kağız məhsulları və “Miniboss” markalı uşaq bezləri kimi istehsalat sahələrində böyük uğurlar əldə edilmişdir. Bu fabriklər, Özbəkistan başda olmaqla bir çox ölkəyə ixrac edirlər.</li>
      <li>Gloria Jeans Coffee markası ilə Rusiya, Ukrayna, İstanbul, Monteneqro, Polşa və Özbəkistan kimi ölkələrdə françayz idarəçiliyi qurulmuşdur və 5 fərqli ölkədə böyümə davam edir.</li>
    </ul>
    
    <ul>
    <strong>Beynəlxalq Layihələr və İnvestisiyalar:</strong>
      <li>Turan Özbahçeci, Dubay və Dohada qurduğu ticarət evləri vasitəsilə Azərbaycan məhsullarını dünya bazarına təqdim etmişdir.</li>
      <li>Azcake Un Fabrikası və Azərbaycanın digər istehsal sahələri ilə yerli iqtisadiyyata böyük töhfələr verilmişdir.</li>
    </ul>
    
    <ul>
    <strong>Karyera Yolları və Layihələr:</strong>
      <li>Yerel Zincirler Buluşuyor konfransının qurucusudur. Bu tədbir 2008-ci ildən bu yana yerli pərakəndəçiləri bir araya gətirir.</li>
      <li>Port Baku Ticarət Mərkəzində yer alan Portpazar mağazası, 2010-cu ildən etibarən Azərbaycanın ən mühüm pərakəndə layihələrindən biri olmuşdur.</li>
    </ul>
    
    <ul>
    <strong>Girişimçilik və İnvestisiya Klubu:</strong>
      <li>Özbahçeci Invest Club adında qurduğu investisiya klubu ilə gənc girişimcilərə investisiya edərək iş dünyasında geniş bir şəbəkə qurmuşdur.</li>
      <li>TAAC DMCC şirkəti ilə 12 şirkəti bir arada idarə edərək global bir iş modeli qurmuşdur.</li>
    </ul>
  `;
  return (
    <>
      <section className="statistika section-title">
        <h2 className="title text-center mt-5" style={{ fontSize: "40px" }}>
          Niyə Özbahçeci İnvestisiya Klubuna <span>üzv olmalısınız?</span>
        </h2>
        <div className="d-flex justify-content-center align-items-center">
          <p
            className="text-center mt-3"
            style={{ maxWidth: "580px", width: "100%" }}
          >
            Bizneslər Şirkətinizin böyüməsini sürətləndirmək üçün 50.000 –
            10.000.000 ABŞ dolları arasında investisiyalar ala bilərsiniz. 3-4
            həftə ərzində investisiya təsdiqi komandamız layihənizi nəzərdən
            keçirəcək və sizin üçün ətraflı hesabat hazırlayacaq
          </p>
        </div>
        <h3 className="title  text-center  mt-5 mb-2">Xidmətlərimiz</h3>
        <h2 className="title fz-48 text-center">
          Bizim <span>Təkliflərimiz</span>
        </h2>
        <div className="container-fluid mt-5 mx-2">
          <div className="row justify-content-center">
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-12"
              data-aos="fade-up"
            >
              <img src={statistika1} alt="" className="img-fluid" />
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-12"
              data-aos="fade-up"
            >
              <h2 className="title fs-3 mt-2">Layihə Dəstəyi</h2>
              <p className="fs-4 mt-3" style={{ lineHeight: "35px" }}>
                Fəaliyyətimizin əsas sahələrindən biri sahibkarlar və
                investorları innovativ layihələri reallaşdırmada
                birləşdirməkdir. Biz bu layihələrin inkişaf potensialını
                qiymətləndirir və layihələrin daha çox insanı təsir etməsinə
                kömək edirik.
              </p>
            </div>

            <div
              className="col-lg-6 col-md-6 col-sm-12 col-12 mt-5"
              data-aos="fade-up"
            >
              <h2 className="title fs-3 mt-2">Layihə Dəstəyi</h2>
              <p className="fs-4 mt-3" style={{ lineHeight: "35px" }}>
                Fəaliyyətimizin əsas sahələrindən biri sahibkarlar və
                investorları innovativ layihələri reallaşdırmada
                birləşdirməkdir. Biz bu layihələrin inkişaf potensialını
                qiymətləndirir və layihələrin daha çox insanı təsir etməsinə
                kömək edirik.
              </p>
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-12 mt-3"
              data-aos="fade-up"
            >
              <img src={statistika2} alt="" className="img-fluid" />
            </div>

            {/* <div className="col-6 mt-5">
              <h2 className="title fz-48 text-center">
              Ümumi <span>Statistikalar:</span>
              </h2>
            </div>
            <div className="col-12 mt-5">
              <p
                className="title fs-6"
                dangerouslySetInnerHTML={{ __html: statistics }}
              />
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Statistika;
